import React from 'react';
import { ReactComponent as ArrowLeftIcon } from '@repo/common/assets/icons/24px/icon_24px_arrow-left.svg';
import { ReactComponent as ArrowRightIcon } from '@repo/common/assets/icons/24px/icon_24px_arrow-right.svg';
import { useT } from '@repo/common';

const PreviewHeader = ({ currentPage = 1, totalPages = 1, onPrev, onNext }) => {
  const t = useT();

  return (
    <div className='w-full flex flex-row justify-between items-center p-0 gap-2 max-w-[348px]'>
      <div className='typo-title1 text-text-primary'>
        {t('preview', '미리보기')}
      </div>
      <div className='flex items-center gap-2'>
        <button
          onClick={onPrev}
          disabled={currentPage === 1}
          aria-label={t('Previous page', '이전 페이지')}
          className='p-1 rounded bg-grayscale-gray02 hover:bg-grayscale-gray03 disabled:opacity-40'
        >
          <ArrowLeftIcon className='w-4 h-4 text-text-primary' />
        </button>

        <span className='text-text-secondary'>
          {currentPage} / {totalPages}
        </span>

        <button
          onClick={onNext}
          disabled={currentPage === totalPages}
          aria-label={t('Next page', '다음 페이지')}
          className='p-1 rounded bg-grayscale-gray02 hover:bg-grayscale-gray03 disabled:opacity-40'
        >
          <ArrowRightIcon className='w-4 h-4 text-text-primary' />
        </button>
      </div>
    </div>
  );
};

export default PreviewHeader;
